module.exports = "/images/Turkey.png?9ac8e0afa0e749398e1c9070d425ca76";